// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_91-0";